<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid v-step-4-1 v-step-4-2">
        <div class="row">
          <div class="col-md-12">
            <div class="material-table-widget dashboard_top_bar">
              <button class="btn btn-default btn-new" @click="CreateProductCategoryModal = true"><i class="fa fa-cubes"></i>&nbsp;新增服務分類</button>
              <button class="btn btn-default btn-new" @click="CreateProductModal = true"><i class="fa fa-cubes"></i>&nbsp;新增服務</button>
            </div>
            <div class="widget-wrap" v-for="product_category,indexPc in orderedProductCategories" v-if="products.length != 0 || product_categories.length != 0">
              <h4 class="text-left" v-if="product_categories.length > 0" >{{product_category.name}} <small>({{filterProductsByPcid(product_category.id).length}})</small>
                <a class="row-edit" @click="UpdateProductCategoryModal = true;update_product_category=product_category"><span class="zmdi zmdi-edit"></span></a>
                <a class="row-edit" @click="DeleteProductCategoryModal = true;delete_product_category=product_category"><span class="zmdi zmdi-close"></span></a>
                <a v-if="indexPc!=(orderedProductCategories.length-1)" class="row-edit pull-right" @click="UpdateProductCategoryOrder(product_category,'down')"><span class="fa fa-arrow-circle-down"></span></a>
                <a v-if="indexPc==(orderedProductCategories.length-1)" class="row-edit pull-right defaul-cursor"><span class="fa fa-arrow-circle-down" style="color:#fff !important"></span></a>
                <a v-if="indexPc!=0" class="row-edit pull-right" @click="UpdateProductCategoryOrder(product_category,'up')"><span class="fa fa-arrow-circle-up"></span></a>
              </h4>
              <div class="row text-left text-gray">
                <div class="col-xs-3">
                  <i class="fa fa-cube"></i> 服務名稱
                </div>
                <div class="col-xs-5">
                  <i class="fa fa-info"></i> 說明
                </div>
                <div class="col-xs-2">
                  <i class="fa fa-dollar-sign"></i> 價格
                </div>
              </div>
              <draggable v-model="filterProducts[indexPc]" class="dragArea full-width text-left" :options="dragOptions"  :move="getDraggedData" @change="onChange($event, product_category)" @start="isDragging=true" @end="isDragging=false">
                <transition-group class="product_drag_area" type="transition" tag="div">
                  <div v-for="product in filterProducts[indexPc]" class="row draggable_product" :key="product.order" v-bind:id="product.product_token">
                    <div class="col-xs-3">
                      <i class="fa fa-bars op-5"></i> {{product.name}}
                    </div>
                    <div class="col-xs-5">
                      <pre class="pre-style">{{product.description}}</pre>
                    </div>
                    <div class="col-xs-2">
                      $ {{product.price.toLocaleString()}}
                    </div>
                    <div class="col-xs-2 text-right">
                      <a class="row-edit" @click="editProduct(product)"><span class="zmdi zmdi-edit"></span></a>
                      <a class="row-edit" @click="DeleteProductModal = true;delete_product=product"><span class="zmdi zmdi-close"></span></a>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
            <div class="widget-wrap"  v-if="products.length != 0 || product_categories.length != 0">
              <h4 class="text-left" ><span v-if="product_categories.length > 0" >未分類</span><span v-else>所有服務</span> <small>({{filterProductsByPcid().length}})</small></h4>
              <div class="row text-left text-gray">
                <div class="col-xs-3">
                  <i class="fa fa-cube"></i> 服務名稱
                </div>
                <div class="col-xs-5">
                  <i class="fa fa-info"></i> 說明
                </div>
                <div class="col-xs-2">
                  <i class="fa fa-dollar-sign"></i> 價格
                </div>
              </div>
              <draggable v-model="noCategoryProducts[0]" class="dragArea full-width text-left product_drag_area" :options="dragOptions"  :move="getDraggedData" @change="onChange($event, null)">
                <transition-group class="product_drag_area" type="transition" tag="div">
                  <div v-for="product in noCategoryProducts[0]" class="row draggable_product" :key="product.order" v-bind:id="product.product_token">
                    <div class="col-xs-4">
                      <i class="fa fa-bars op-5"></i> {{product.name}}
                    </div>
                    <div class="col-xs-4">
                      {{product.description}}
                    </div>
                    <div class="col-xs-2">
                      $ {{product.price.toLocaleString()}}
                    </div>
                    <div class="col-xs-2 text-right">
                      <a class="row-edit" @click="UpdateProductModal = true;update_product=product"><span class="zmdi zmdi-edit"></span></a>
                      <a class="row-edit" @click="DeleteProductModal = true;delete_product=product"><span class="zmdi zmdi-close"></span></a>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
            <div class="widget-wrap" v-if="products.length == 0 && product_categories.length == 0">
              <div class="row">
                <div class="col-xs-2 offset-2">
                  <img src="/static/img/chill.4a2c19d.png" class="teach-img">
                </div>
                <div class="col-xs-6 text-left">
                  <h4>快來編輯新增你的服務目錄，您將獲得巨大的好處：</h4>
                  <ol>
                    <li>報價速度倍增！快速產生報價單</li>
                    <li>追蹤你的服務銷售比率</li>
                    <li>新進人員，只需看你的服務就能馬上進入狀況</li>
                  </ol>
                  <span>馬上花點小時間，整理好你的服務目錄吧！</span><br>
                  <button class="btn btn-default btn-new" @click="CreateProductCategoryModal = true"><i class="fa fa-cubes"></i>&nbsp;新增服務分類</button>
              <button class="btn btn-default btn-new" @click="CreateProductModal = true"><i class="fa fa-cubes"></i>&nbsp;新增服務</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template start-->
    <div v-if="CreateProductModal" @keyup.esc="CreateProductModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="CreateProductModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                新增服務
              </div>
              <a href="#" class="btn-close" @click="CreateProductModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body">
              <div class="form-group j-forms">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-cube"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="服務名稱*" name="name" v-model="name" v-validate="'required:true'">
                </div>
                <i v-show="errors.has('name')" class="fa fa-warning"></i>
                <span v-show="errors.has('name')" class="help is-danger">請輸入服務名稱</span>
              </div>
              <div class="form-group j-forms" v-if="orderedProductCategories.length > 0">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-cube"></i></label>
                  <select class="form-control login-frm-input" name="product_category_id" v-model="product_category_id" v-validate="'required:true'">
                    <option disabled value="">請選擇一個服務分類</option>
                    <option v-for="product_category in orderedProductCategories" v-bind:value="product_category.id">{{product_category.name}}</option>
                  </select>
                </div>
                <i v-show="errors.has('product_category_id')" class="fa fa-warning"></i>
                <span v-show="errors.has('product_category_id')" class="help is-danger">請選擇一個分類</span>
              </div>
              <div class="form-group j-forms">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-dollar-sign"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="價格*" name="price" v-model="price" v-validate="'required|numeric'">
                </div>
                <i v-show="errors.has('price')" class="fa fa-warning"></i>
                <span v-show="errors.has('price')" class="help is-danger">請輸入數字
                </span>
              </div>
              <div class="form-group">
                <textarea v-autosize="description" rows="3" class="bootstrap_textarea" placeholder="說明*" name="description"  v-validate="'required:true'" v-model="description"></textarea>
                <i v-show="errors.has('description')" class="fa fa-warning"></i>
                <span v-show="errors.has('description')" class="help is-danger">請輸入此服務的描述或規格</span>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="validateBeforeSubmit">
                  建立
                </button>
                <button class="btn btn-default" @click="CreateProductModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="UpdateProductModal" @keyup.esc="UpdateProductModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="UpdateProductModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                更新服務
              </div>
              <a href="#" class="btn-close" @click="UpdateProductModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-cube"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="服務名稱" name="name" v-model="update_product.name" v-validate="'required:true'">
                </div>
                <i v-show="errors.has('name')" class="fa fa-warning"></i>
                <span v-show="errors.has('name')" class="help is-danger">請輸入服務名稱</span>
              </div>
              <div class="form-group" v-if="orderedProductCategories.length > 0">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-cube"></i></label>
                  <select class="form-control login-frm-input" name="product_category_id" v-model="update_product.product_category_id" v-validate="'required:true'">
                    <option disabled value="">請選擇一個服務分類</option>
                    <option v-for="product_category in orderedProductCategories" v-bind:value="product_category.id">{{product_category.name}}</option>
                  </select>
                </div>
                <i v-show="errors.has('product_category_id')" class="fa fa-warning"></i>
                <span v-show="errors.has('product_category_id')" class="help is-danger">請選擇一個分類</span>
              </div>
              <div class="form-group">
                <textarea v-autosize="description" rows="3" class="bootstrap_textarea" placeholder="說明*" name="description"  v-validate="'required:true'" v-model="update_product.description"></textarea>
                <i v-show="errors.has('description')" class="fa fa-warning"></i>
                <span v-show="errors.has('description')" class="help is-danger">請輸入此服務的描述或規格</span>
              </div>
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-dollar-sign"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="價格" name="price" v-model="update_product.price" v-validate="'required|numeric'">
                </div>
                <i v-show="errors.has('price')" class="fa fa-warning"></i>
                <span v-show="errors.has('price')" class="help is-danger">請輸入數字
                </span>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateProduct(update_product)">
                  更新
                </button>
                <button class="btn btn-default" @click="UpdateProductModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="DeleteProductModal" @keyup.esc="DeleteProductModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="DeleteProductModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                你確定要刪除此服務？
              </div>
              <a href="#" class="btn-close" @click="DeleteProductModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <p>你即將刪除「{{delete_product.name}}」，此項步驟無法回覆。刪除此項服務不會影響報價單，以及各種已完成未完成訂單。</p>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-danger" @click="DeleteProduct(delete_product)">
                  確認刪除
                </button>
                <button class="btn btn-default" @click="DeleteProductModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="CreateProductCategoryModal" @keyup.esc="CreateProductCategoryModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="CreateProductCategoryModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                新增服務分類
              </div>
              <a href="#" class="btn-close" @click="CreateProductCategoryModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-cube"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="服務分類名稱*" name="category_name" v-model="category_name" v-validate="'required:true'">
                </div>
                <i v-show="errors.has('category_name')" class="fa fa-warning"></i>
                <span v-show="errors.has('category_name')" class="help is-danger">請輸服務分類名稱</span>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="validateBeforeSubmitCategory">
                  建立
                </button>
                <button class="btn btn-default" @click="CreateProductCategoryModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="UpdateProductCategoryModal" @keyup.esc="UpdateProductCategoryModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="UpdateProductCategoryModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                更新服務分類
              </div>
              <a href="#" class="btn-close" @click="UpdateProductCategoryModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <div class="form-group">
                <div class="input left-icon-input">
                  <label for="text" class="icon-left"><i class="fa fa-cube"></i></label>
                  <input class="form-control login-frm-input" type="text" placeholder="服務分類名稱*" name="category_name" v-model="update_product_category.name" v-validate="'required:true'">
                </div>
                <i v-show="errors.has('category_name')" class="fa fa-warning"></i>
                <span v-show="errors.has('category_name')" class="help is-danger">請輸服務分類名稱</span>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateProductCategory(update_product_category)">
                  更改
                </button>
                <button class="btn btn-default" @click="UpdateProductCategoryModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="DeleteProductCategoryModal" @keyup.esc="DeleteProductCategoryModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="DeleteProductCategoryModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                你確定要刪除此分類嗎？
              </div>
              <a href="#" class="btn-close" @click="DeleteProductCategoryModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <p>你即將刪除「{{delete_product_category.name}}」，此項步驟無法回覆。</p>
              <p>刪除此項服務分類後，此分類底下的服務會移動到未分類，不會直接刪除</p>
              <p>刪除此項服務分類不會影響報價單，以及各種已完成未完成訂單。</p>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-danger" @click="DeleteProductCategory(delete_product_category)">
                  確認刪除
                </button>
                <button class="btn btn-default" @click="DeleteProductCategoryModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!--Page Container End Here-->
  </div>
</template>

<script>
import { getCookie, setCookie } from '../assets/js/elffy_js/cookie.js'
import draggable from 'vuedraggable'

export default {
  name: 'products',
  components: {
    draggable,
  },
  data() {
    return {
      products: [],
      product_categories: [],
      CreateProductModal: false,
      UpdateProductModal: false,
      DeleteProductModal: false,
      CreateProductCategoryModal: false,
      UpdateProductCategoryModal: false,
      DeleteProductCategoryModal: false,
      description: '',
      name: '',
      price: '',
      product_category_id: '',
      update_product: {},
      category_name: '',
      dragged_data: '',
    }
  },
  created() {
    this.getProducts();
    this.getProductCategories();
  },
  props: ['toggle_aside'],
  computed: {
    orderedProducts: function () {
      //return this.products
      return _.orderBy(this.products, 'order')
    },
    orderedProductCategories: function () {
      //return this.product_categories
      return _.orderBy(this.product_categories, 'order')
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'product_category_box',
        ghostClass: 'ghost'
      }
    },
    filterProducts: function() { 
      var pc_len = this.orderedProductCategories.length
      var return_products = [];
      const vm = this;
      //將服務分類
      for (var i = 0; i <= pc_len - 1; ++i) {
        return_products[i] = vm.orderedProducts.filter(product => product.product_category_id == vm.orderedProductCategories[i].id)
        //分類完畢，開始確認每個服務的order是否正確，不正確就更新
        // for (var ii = 0; ii <= return_products[i].length - 1; ++ii) {
        //   if(return_products[i][ii].order != ii){
        //     return_products[i][ii].order = ii;
        //     
        //   }
        // }
      }
      return return_products
    },
    noCategoryProducts: function() {
      var return_products = [];
      return_products[0] = this.orderedProducts.filter(product => product.product_category_id == null)
      return return_products
    },
  },
  methods: {
    getDraggedData: function(event) {
      this.dragged_data = event
    },
    onChange: function(event,pc) {
      var pcid = null
      if(pc != null){
        pcid = pc.id
      }
      var vm = this;
      var ps = vm.filterProductsByPcid(pcid)
      var pindex = 0
      var order = 0
      var changed_product
      var newIndex
      //if moved order ,no change category
      //change order one by one
      if(event.moved){
        newIndex = event.moved.newIndex
        changed_product = event.moved.element
        //開始重置這個分類的順序
        ps.forEach(function(p,index){
          if(p != changed_product){
            //如果這個物件的位子，不是位於即將插入的物件的位子，則依序往下排
            if(newIndex == order){
            //如果這個物件卡到新的位子，就往下移動一個位子  
              order += 1
            }
            pindex =  vm.products.indexOf(p)
            p.order = order;
            vm.$set(vm.products, pindex, p);
            order += 1
          }else{
            pindex =  vm.products.indexOf(p)
            p.order = newIndex;
            vm.$set(vm.products, pindex, p);
          }
        })
        //重置結束
        vm.UpdateAllProduct();
      }
      //如果是換分類，新增的分類，更換分類後重置順序
      if(event.added){
        order = 0
        newIndex = event.added.newIndex
        changed_product = event.added.element
        changed_product.product_category_id = pcid
        pindex =  vm.products.indexOf(changed_product)
        vm.$set(vm.products, pindex, changed_product);
        ps = vm.filterProductsByPcid(pcid)
        //開始重置這個分類的順序
        ps.forEach(function(p,index){
          if(p != changed_product){
            //如果這個物件的位子，不是位於即將插入的物件的位子，則依序往下排
            if(newIndex == order){
            //如果這個物件卡到新的位子，就往下移動一個位子  
              order += 1
            }
            pindex =  vm.products.indexOf(p)
            p.order = order;
            vm.$set(vm.products, pindex, p);
            order += 1
          }else{
            pindex =  vm.products.indexOf(p)
            p.order = newIndex;
            vm.$set(vm.products, pindex, p);
          }
        })
        //重置結束
      }
      //把移動過的舊的排序也重置
      if(event.removed){
        order = 0
        newIndex = event.removed.newIndex
        //開始重置這個分類的順序
        ps.forEach(function(p,index){
          if(p != changed_product){
            //如果這個物件的位子，不是位於即將插入的物件的位子，則依序往下排
            if(newIndex == order){
            //如果這個物件卡到新的位子，就往下移動一個位子  
              order += 1
            }
            pindex =  vm.products.indexOf(p)
            p.order = order;
            vm.$set(vm.products, pindex, p);
            order += 1
          }else{
            pindex =  vm.products.indexOf(p)
            p.order = newIndex;
            vm.$set(vm.products, pindex, p);
          }
        })
        //重置結束 
        vm.UpdateAllProduct();
      }
    },
    onEnd: function(event) {

    },
    onMove: function(event) {

    },
    getProducts() {
      const vm = this;
      this.axios.get('products')
        .then(function(response) {
          if (response.status == 200) {
            vm.products = response['data']['data']['products']
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    getProductById(pid){
      let vm=this
      var result={}
      $.each(this.products,function(key,value){
        if(parseInt(value.id)==parseInt(pid)){
          result = value
        }
      })
      return result
    },
    getProductCategories() {
      const vm = this;
      this.axios.get('product_categories')
        .then(function(response) {
          if (response.status == 200) {
            vm.product_categories = response['data']['data']['product_categories']
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    editProduct(product){
      this.update_product.name = product.name
      this.update_product.product_category_id = product.product_category_id
      this.update_product.price = product.price
      this.update_product.description = product.description
      this.update_product.id = product.id
      this.update_product.order = product.order
      this.update_product.company_id = product.company_id
      this.update_product.product_token = product.product_token
      this.UpdateProductModal = true;
    },
    filterProductsByPcid(pcid) {
      var return_products = this.orderedProducts.filter(product => product.product_category_id == pcid)
      return return_products
    },
    // ShowProduct(product_token) {
    //   this.$router.push({ name: 'product', params: { product_token: product_token } })
    // },
    // validation input
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.CreateProduct();
        } else {
          console.log('fails')
        }
      });
    },
    validateBeforeSubmitCategory() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.CreateProductCategory();
        } else {
          console.log('fails')
        }
      });
    },
    CreateProduct() {
      const vm = this;
      this.axios.post('products', {
          product: {
            name: this.name,
            price: this.price,
            description: this.description,
            product_category_id: this.product_category_id
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.CreateProductModal = false
            vm.products.push(response['data']['data']['product'])
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    UpdateProduct(product){
      this.$validator.validateAll().then((result) => {
        if (result) {
          const vm = this;
          this.axios.put('products/:id', {
            product
          })
          .then(function(response) {
            if (response.status == 200) {
              var oldProduct = vm.getProductById(product.id)
              var index = vm.products.indexOf(oldProduct)
              vm.products.splice(parseInt(index), 1)
              var new_event = response['data']['data']
              vm.products.push(new_event)
              vm.UpdateProductModal = false
            } else {
              console.log(response)
            }
          })
          .catch(function(error) {
            console.log('error:', error)
          });
        } else {
          console.log('fails')
        }
      });
    },
    DeleteProduct(product){
      // delete in html
      var index = this.products.indexOf(product)
      this.products.splice(parseInt(index), 1)
      const vm = this;
      vm.DeleteProductModal=false
      this.axios.delete('products/:id', {
        params: {
          product_token: product.product_token
        }
      })
      .then(function(response) {
        if (response.status == 200) {} else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    CreateProductCategory() {
      const vm = this;
      this.axios.post('product_categories', {
        product_category: {
          name: this.category_name
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.CreateProductCategoryModal = false
          vm.product_categories.push(response['data']['data']['product_category'])
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    UpdateProductCategory(product_category) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const vm = this;
          this.axios.put('product_categories/:id', {
            product_category
          })
          .then(function(response) {
            if (response.status == 200) {
              vm.UpdateProductCategoryModal = false
            } else {
              console.log(response)
            }
          })
          .catch(function(error) {
            console.log('error:', error)
          });
        } else {
          console.log('fails')
        }
      });
    },
    DeleteProductCategory(product_category) {
      // delete in html
      var index = this.product_categories.indexOf(product_category)
      this.product_categories.splice(parseInt(index), 1)
      const vm = this;
      // move products to other category
      _.forEach(vm.filterProductsByPcid(product_category.id), function(product) {
        product.product_category_id = null;
        index = vm.products.indexOf(product);
        vm.$set(vm.products, index, product);
      });

      vm.DeleteProductCategoryModal=false
      this.axios.delete('product_categories/:id', {
        params: {
          product_category_token: product_category.product_category_token
        }
      })
      .then(function(response) {
        if (response.status == 200) {} else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    UpdateProductCategoryOrder(product_category,go){
      var vm = this;
      var newIndex = 0
      var order = 0
      var pcindex
      var oldIndex = vm.orderedProductCategories.indexOf(product_category) ;
      if(go == "up"){
        newIndex = oldIndex-1
      }else{
        newIndex = oldIndex+1
      }
      
      //newIndex = event.removed.newIndex ;
      console.log(newIndex);
      //開始重置分類的順序
      this.orderedProductCategories.forEach(function(pc,index){
        if(pc != product_category){
          //如果這個物件的位子，不是位於即將插入的物件的位子，則依序往下排
          if(newIndex == order){
          //如果這個物件卡到新的位子，就往下移動一個位子  
            order += 1
          }
          pcindex =  vm.product_categories.indexOf(pc)
          pc.order = order;
          vm.$set(vm.product_categories, pcindex, pc);
          order += 1
        }else{
          pcindex =  vm.product_categories.indexOf(pc)
          pc.order = newIndex;
          vm.$set(vm.product_categories, pcindex, pc);
        }
      })
      //重置結束 
      vm.UpdateAllProductCategories();
    },
    UpdateAllProduct() {
      //更新所有服務的排序與分類
      this.axios.post('products/update_product_onpc', {
          products: this.products
        })
        .then(function(response) {
          if (response.status == 200) {
          } else {
            console.log('Update order Fail')
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    UpdateAllProductCategories() {
      //更新所有服務的排序與分類
      this.axios.post('product_categories/update_order', {
          product_categories: this.product_categories
        })
        .then(function(response) {
          if (response.status == 200) {
          } else {
            console.log('Update order Fail')
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
  }
}
</script>


// WEBPACK FOOTER //
// ProductList.vue?5a057656